define('views/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-content-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/toastr-service',
    'services/i18n',
    // parents views
    'src/views/form-view',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/calendar/animated-session/custom-exercises-manager/form/exercise-form',
    'views/parts/alert/alert-list'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    ToastrService,
    i18n,
    // parent views
    VForm,
    // views
    VMenuSaveAction,
    VExerciseForm,
    VAlertList
) {

    var VCustomExerciseEditContentModal = VForm.extend({

        template: '<div class="panel-body exercise-edit-content"><div class="alert-list"></div><div class="exercise-edit-form"></div></div>',

        regions: {
            root: ".exercise-edit-content",
            form: ".exercise-edit-form",
            alert: ".alert-list"
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = this.options.group;

            var view = this.view = {
                form: new VExerciseForm({
                    model: this.model,
                }),
                alert: new VAlertList()
            };

            this.listenTo(this.model, { 'change': this.onModelChange });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.setPristine();

            this.assign(view.form, zone.$form)
                .assign(view.alert, zone.$alert);

        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onSubmit: function() {
            var model = this.model;
            if (model.isNew()) {
                model.set('group', this.group.id);
            }

            if (!model.has('animationUrl')) {
                model.unset('animation');
            }
        },

        onSave: function() {
            var animationUrl = this.model.get('animation') && this.model.get('animation').url;
            if (animationUrl != null && animationUrl.trim() === "") {
                delete this.model.attributes.animation;
            }
            this.submit();
        },

        onError: function() {
            ToastrService.warn('api-messages:INVALID-URL');
        },

        onSuccess: function() {
            this.trigger('form:success', this.model.clone());
        },

        onInvalid: function() {
            this.view.alert.reset();

            _.each(this.model.validationError, function(errors) {
                this.view.alert.addError(i18n.t(errors[0]));
            }, this);
        }
    });

    return VCustomExerciseEditContentModal;

});

